import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TLiftedFormModel } from '@monorepo/ui';
import * as OrderAttributesActions from './order-attributes.actions';
import * as OrderAttributesSelectors from './order-attributes.selectors';
import {
  TREQUEST_ADD_UPDATE_ORDER_ATTRIBUTES,
  TREQUEST_DELETE_ORDER_ATTRIBUTES,
  TREQUEST_ORDER_ATTRIBUTES,
} from '@monorepo/types';

export const ORDER_ATTRIBUTES_ITEMS_PER_PAGE_LIST = [10, 50, 100, 200];

@Injectable({
  providedIn: 'root',
})
export class OrderAttributesFacade {
  constructor(private store: Store<TPlani8State>) {}

  fetchOrderAttributesInfo(payload: TREQUEST_ORDER_ATTRIBUTES) {
    this.store.dispatch(new OrderAttributesActions.GetOrderAttributesInfo(payload));
  }

  fetchOrderAttributesTypesInfo() {
    this.store.dispatch(new OrderAttributesActions.GetOrderAttributesTypesInfo());
  }

  addUpdateOrderAttributes(
    updateOrderAttributesPayload: TREQUEST_ADD_UPDATE_ORDER_ATTRIBUTES,
    getOrderAttributesPayload: TREQUEST_ORDER_ATTRIBUTES,
  ) {
    this.store.dispatch(
      new OrderAttributesActions.AddUpdateOrderAttributes(updateOrderAttributesPayload, getOrderAttributesPayload),
    );
  }

  deleteOrderAttributes(
    deleteOrderAttributesPayload: TREQUEST_DELETE_ORDER_ATTRIBUTES,
    getOrderAttributesPayload: TREQUEST_ORDER_ATTRIBUTES,
  ) {
    this.store.dispatch(
      new OrderAttributesActions.DeleteOrderAttributes(deleteOrderAttributesPayload, getOrderAttributesPayload),
    );
  }

  getOrderAttributesInfo() {
    return this.store.pipe(select(OrderAttributesSelectors.getOrderAttributesInfo));
  }

  getOrderAttributesTypesInfo() {
    return this.store.pipe(select(OrderAttributesSelectors.getOrderAttributesTypesInfo));
  }
}

export type TGetOrderAttributesInfo = ReturnType<OrderAttributesFacade['getOrderAttributesInfo']>;
export type TGetOrderAttributesTypesInfo = ReturnType<OrderAttributesFacade['getOrderAttributesTypesInfo']>;
